<template>
  <div class="font-bebas text-3xl text-arter-secundaria">
    <slot></slot>
  </div>
</template>
